import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN, Array } from '@blade/std-lib'
import { InfoMessage } from '@root/shared/ui-kit'

import { type FollowingsFilter } from '../atoms/user-followings-filter'

import { UserConnectionsFollowing } from './user-connections-following'
import { UserConnectionsItem } from './user-connections-item/user-connections-item'

type Props = {
  followingsFilter: FollowingsFilter
}

export const UserConnectionsFollowings = ({
  followingsFilter: followingFilter,
}: Props) => {
  const [filterItemsState] = useAtom(followingFilter.filterItemsStateAtom)
  const refreshFilter = useAction(followingFilter.filterItemsStateAtom.refresh)

  return AsyncStateN.matchWaiting(filterItemsState, {
    Error: () => (
      <InfoContainer>
        <InfoMessage intent={'error'} variant="dt" onRetry={refreshFilter} />
      </InfoContainer>
    ),
    Waiting: () => (
      <FilterResult>
        {Array.range(0, 5).map((x) => (
          <UserConnectionsItem.Skeleton key={x} />
        ))}
      </FilterResult>
    ),
    Success: Array.match({
      onEmpty: () => (
        <InfoContainer>
          <InfoMessage intent={'empty'} variant="dt" />
        </InfoContainer>
      ),
      onNonEmpty: (followings) => (
        <FilterResult>
          {followings.map((following) => (
            <UserConnectionsFollowing
              following={following}
              key={following.delugeId}
            />
          ))}
        </FilterResult>
      ),
    }),
  })
}

const FilterResult = styled.div`
  z-index: 0;
  display: grid;
  grid-auto-rows: max-content;
  gap: 6px;
`

const InfoContainer = styled.div`
  display: grid;
`
